import { Reveal } from "../Reveal";
import { APPROCCIO } from "../../data/content";

export const Approccio = () => (
  <section
    id="approccio"
    data-testid="approccio-section"
    className="relative border-t border-[#16181a]/12 bg-[#eae3d0]"
  >
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-14 md:py-32">
      <div className="mb-16 grid grid-cols-12 gap-8 md:mb-20">
        <Reveal className="col-span-12 md:col-span-6">
          <div className="flex items-baseline gap-4">
            <span className="font-display text-2xl italic text-[#c0442b]">03</span>
            <span className="overline">Il mio approccio</span>
          </div>
          <h2 className="mt-6 font-display text-4xl font-light leading-[1.05] tracking-tight text-[#16181a] md:text-6xl">
            Quattro momenti,{" "}
            <span className="italic text-[#c0442b]">senza formule</span>.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="col-span-12 md:col-span-5 md:col-start-8">
          <p className="font-body text-base leading-relaxed text-[#2a2b2d] md:text-lg">
            Non ho un metodo confezionato. Ho un modo di stare nei progetti fatto di attenzione,
            direzione e cura — quattro passaggi che si adattano a ciò che ho davanti.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
        {APPROCCIO.map((step, i) => (
          <Reveal key={step.n} delay={(i % 2) * 0.1}>
            <div
              data-testid={`approccio-step-${step.n}`}
              className="relative flex h-full flex-col justify-between border border-[#16181a]/20 bg-[#f0ead9] p-8 md:p-12"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-display text-6xl italic leading-none text-[#c0442b] md:text-7xl">
                  {step.n}
                </span>
                <div className="h-px flex-1 translate-y-[-14px] ml-8 bg-[#16181a]/20" />
              </div>
              <h3 className="mt-10 font-display text-3xl font-light text-[#16181a] md:text-4xl">
                {step.title}
              </h3>
              <p className="mt-6 max-w-md font-body text-base leading-relaxed text-[#2a2b2d]">
                {step.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
